import '/assets/styles/layouts/_web.scss';

const WebLayout = ({ children }) => {
	return <div className="web-layout">{children}</div>;
};

export default WebLayout;
